// extracted by mini-css-extract-plugin
export default {"mainContainer":"main-layout_mainContainer__W9PEr"};